/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withExpContextRule } from '@thd-olt-component-middleware/pip';

import { PIPRedirector }
from '@thd-nucleus/app-render';

import { ProductMetadata }
from '@thd-olt-component-react/metadata';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { PIPSharebelt }
from '@thd-olt-component-react/thd-sharebelt';

import { ConnectedTranslatorWidget }
from '@thd-olt-component-react/translator_widget';

import { DynamicRecsWrapperPip, RecentlyViewedWrapper }
from '@thd-olt-component-react/thd-recs-containers';

import { Discontinued }
from '@thd-olt-component-react/discontinued';

import { PIPProductDetails }
from '@thd-olt-component-react/product-details';

import { MediaGalleryWithHotspotsCarousel }
from '@thd-olt-component-react/media-gallery';

import { RoomVo, RoomVoInspire, BathRenovation }
from '@thd-olt-component-react/augmented-reality';

import { ProductPageEventCountdownTimer }
from '@thd-olt-component-react/event-countdown-timer';

import { PromotionUrgencyMessaging, Promotion }
from '@thd-olt-component-react/promotion';

import { PIPPriceClearanceWrapper }
from '@thd-olt-component-react/price';

import { PromotionProductsAnchor }
from '@thd-olt-component-react/promotion-products';

import { CalcLink }
from '@thd-olt-component-react/moving-calculator';

import { ConfiguratorAndPipFlipLayout }
from '@thd-olt-component-react/product-configurator';

import { BuyboxWithPIPCalculator }
from '@thd-olt-component-react/buybox';

import { BundlePmvFbtLayoutGmAndHdh }
from '@thd-olt-component-react/bundle-mini';

import { ProductInfoBar }
from '@thd-olt-component-react/product-info-bar';

import { ProductOverviewAccordionTitle }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle }
from '@thd-olt-component-react/ratings-and-reviews';

import { BazaarVoiceCarousel }
from '@thd-olt-component-react/social-media-container';

import { SponsoredPipBanner }
from '@thd-olt-component-react/sponsored-content';

import { EducationalSummary }
from '@thd-olt-component-react/educational-summary';

import { RetailMediaCarouselFusionPIP }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { FeatureBasedRecommendationsImporterVite }
from '@thd-olt-component-react/feature-based-recommendations';

import { TextAnExpert }
from '@thd-olt-component-react/text-an-expert';

import { RelatedSearch, RelatedProducts, PopularVariations }
from '@thd-olt-component-react/related-search';

import { EmtLinks }
from '@thd-olt-component-react/emt-links';

import { DigitalTicket }
from '@thd-olt-component-react/digital-ticket';

import { AugmentedReality as AugmentedRealitySSR } from '@thd-olt-component-react/augmented-reality?clientSideRemove';

import { DisclaimerMessage as DisclaimerMessageSSR } from '@thd-olt-component-react/disclaimer-message?clientSideRemove';

import { ConsumerCardMessaging as ConsumerCardMessagingSSR } from '@thd-olt-component-react/consumer-card-messaging?clientSideRemove';

import { GlobalCustomConfigurator as GlobalCustomConfiguratorSSR } from '@thd-olt-component-react/global-custom-configurator?clientSideRemove';

import { AisleBay as AisleBaySSR } from '@thd-olt-component-react/aisle-bay?clientSideRemove';

import { SuperSku as SuperSkuSSR } from '@thd-olt-component-react/super-sku?clientSideRemove';

import { OrderSample as OrderSampleSSR } from '@thd-olt-component-react/order-sample?clientSideRemove';

import { NoOp as NoOpSSR } from '@thd-nucleus/app-render?clientSideRemove';

import { ReturnsMessaging as ReturnsMessagingSSR } from '@thd-olt-component-react/returns-messaging?clientSideRemove';

import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSSR, ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSSR, SpecificationsAccordionBody as SpecificationsAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSSR, QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSSR, RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

export { PIPRedirector };

export { ProductMetadata };

export { Breadcrumbs };

export { PIPSharebelt };

export { ConnectedTranslatorWidget };

export { DynamicRecsWrapperPip };

export { Discontinued };

export { PIPProductDetails };

export { MediaGalleryWithHotspotsCarousel };

export { RoomVo };

export { ProductPageEventCountdownTimer };

export { PromotionUrgencyMessaging };

export { PIPPriceClearanceWrapper };

export { Promotion };

export { PromotionProductsAnchor };

export { CalcLink };

export { ConfiguratorAndPipFlipLayout };

export { BuyboxWithPIPCalculator };

export { BundlePmvFbtLayoutGmAndHdh };

export { ProductInfoBar };

export { ProductOverviewAccordionTitle };

export { SpecificationsAccordionTitle };

export { QuestionsAndAnswersAccordionTitle };

export { RatingsAndReviewsAccordionTitle };

export { BazaarVoiceCarousel };

export { RoomVoInspire };

export { BathRenovation };

export { SponsoredPipBanner };

export { EducationalSummary };

export { RetailMediaCarouselFusionPIP };

export { FeatureBasedRecommendationsImporterVite };

export { TextAnExpert };

export { RecentlyViewedWrapper };

export { RelatedSearch };

export { RelatedProducts };

export { PopularVariations };

export { EmtLinks };

export { DigitalTicket };

const SlotA1 = withLayout(
  [

    PIPRedirector,

  ],

);

const SlotA2 = withLayout(
  [

    ProductMetadata,

  ],

);

const SlotB1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotC1 = withLayout(
  [

    PIPSharebelt,

  ],

);

const SlotC2 = withLayout(
  [

    ConnectedTranslatorWidget,

  ],

);

const SlotD1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotD2 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotD3 = withLayout(
  [

    Discontinued,

  ],

);

const SlotE1 = withLayout(
  [

    PIPProductDetails,

  ],

);

const SlotE2 = withLayout(
  [

    MediaGalleryWithHotspotsCarousel,

  ],

);

const SlotE3 = withLayout(
  [

    RoomVo,

  ],

);

const SlotF1 = withLayout(
  [

    ProductPageEventCountdownTimer,

  ],

);

const SlotF2 = withLayout(
  [

    PromotionUrgencyMessaging,

  ],

);

const SlotF4 = withLayout(
  [

    PIPPriceClearanceWrapper,

  ],

);

const SlotF5 = withLayout(
  [

    Promotion,

  ],

);

const SlotF8 = withLayout(
  [

    PromotionProductsAnchor,

  ],

);

const SlotF10 = withLayout(
  [

    CalcLink,

  ],

);

const SlotF13 = withLayout(
  [

    ConfiguratorAndPipFlipLayout,

  ],

);

const SlotF15 = withLayout(
  [

    BuyboxWithPIPCalculator,

  ],

);

const SlotG1 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG2 = withLayout(
  [

    BundlePmvFbtLayoutGmAndHdh,

  ],

);

const SlotG3 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG4 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG5 = withLayout(
  [

    ProductInfoBar,

  ],

);

const SlotG9 = withLayout(
  [

    BazaarVoiceCarousel,

  ],

);

const SlotG10 = withLayout(
  [

    RoomVoInspire,

  ],

);

const SlotG11 = withLayout(
  [

    BathRenovation,

  ],

);

const SlotG12 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG13 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG14 = withLayout(
  [

    SponsoredPipBanner,

  ],

);

const SlotG15 = withLayout(
  [

    EducationalSummary,

  ],

);

const SlotG16 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG17 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG18 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG19 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG20 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG21 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG22 = withLayout(
  [

    RetailMediaCarouselFusionPIP,

  ],

);

const SlotG23 = withLayout(
  [

    FeatureBasedRecommendationsImporterVite,

  ],

);

const SlotG24 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

let RulesMiddleware_MiddlewareSlot_SlotG25 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotG25 = withExpContextRule(RulesMiddleware_MiddlewareSlot_SlotG25, { render: { name: 'isConsumerApp', negate: true } });

const SlotG25 = withLayout(
  [

    TextAnExpert,

  ],

  RulesMiddleware_MiddlewareSlot_SlotG25

);

const SlotG26 = withLayout(
  [

    RecentlyViewedWrapper,

  ],

);

const SlotG27 = withLayout(
  [

    RelatedSearch,

  ],

);

const SlotG28 = withLayout(
  [

    RelatedProducts,

  ],

);

const SlotG29 = withLayout(
  [

    PopularVariations,

  ],

);

const SlotG30 = withLayout(
  [

    EmtLinks,

  ],

);

const SlotG31 = withLayout(
  [

    DigitalTicket,

  ],

);

const ssr = typeof window === 'undefined';

const SlotF3Index0DataModel = ssr
  ? AugmentedRealitySSR
  : {};

const SlotF6Index0DataModel = ssr
  ? DisclaimerMessageSSR
  : {};

const PLCCAboveIndex0DataModel = ssr
  ? ConsumerCardMessagingSSR
  : {};

const SlotF9Index0DataModel = ssr
  ? GlobalCustomConfiguratorSSR
  : {};

const SlotF11Index0DataModel = ssr
  ? AisleBaySSR
  : {};

const SlotF12Index0DataModel = ssr
  ? SuperSkuSSR
  : {};

const SlotF14Index0DataModel = ssr
  ? OrderSampleSSR
  : {};

const PLCCBelowIndex0DataModel = ssr
  ? NoOpSSR
  : {};

const PLCCBelowIndex1DataModel = ssr
  ? ConsumerCardMessagingSSR
  : {};

const SlotF17Index0DataModel = ssr
  ? ReturnsMessagingSSR
  : {};

const SlotG6Index0DataModel = ssr
  ? BotPromptSSR
  : {};

const SlotG7KTitle1Index0DataModelK0 = ssr
  ? ProductOverviewAccordionTitleSSR
  : {};

const SlotG7KBody1Index0DataModelBodyK0 = ssr
  ? ProductOverviewAccordionBodySSR
  : {};

const SlotG7KTitle2Index1DataModelK0 = ssr
  ? SpecificationsAccordionTitleSSR
  : {};

const SlotG7KBody2Index1DataModelBodyK0 = ssr
  ? SpecificationsAccordionBodySSR
  : {};

const SlotG7KTitle3Index2DataModelK0 = ssr
  ? QuestionsAndAnswersAccordionTitleSSR
  : {};

const SlotG7KBody3Index2DataModelBodyK0 = ssr
  ? QuestionsAndAnswersAccordionBodySSR
  : {};

const SlotG7KTitle4Index3DataModelK0 = ssr
  ? RatingsAndReviewsAccordionTitleSSR
  : {};

const SlotG7KBody4Index3DataModelBodyK0 = ssr
  ? RatingsAndReviewsAccordionBodySSR
  : {};

const SlotG8Index0DataModel = ssr
  ? BotPromptSSR
  : {};

export {

  SlotA1,

  SlotA2,

  SlotB1,

  SlotC1,

  SlotC2,

  SlotD1,

  SlotD2,

  SlotD3,

  SlotE1,

  SlotE2,

  SlotE3,

  SlotF1,

  SlotF2,

  SlotF4,

  SlotF5,

  SlotF8,

  SlotF10,

  SlotF13,

  SlotF15,

  SlotG1,

  SlotG2,

  SlotG3,

  SlotG4,

  SlotG5,

  SlotG9,

  SlotG10,

  SlotG11,

  SlotG12,

  SlotG13,

  SlotG14,

  SlotG15,

  SlotG16,

  SlotG17,

  SlotG18,

  SlotG19,

  SlotG20,

  SlotG21,

  SlotG22,

  SlotG23,

  SlotG24,

  SlotG25,

  SlotG26,

  SlotG27,

  SlotG28,

  SlotG29,

  SlotG30,

  SlotG31,

  SlotF3Index0DataModel,

  SlotF6Index0DataModel,

  PLCCAboveIndex0DataModel,

  SlotF9Index0DataModel,

  SlotF11Index0DataModel,

  SlotF12Index0DataModel,

  SlotF14Index0DataModel,

  PLCCBelowIndex0DataModel,

  PLCCBelowIndex1DataModel,

  SlotF17Index0DataModel,

  SlotG6Index0DataModel,

  SlotG7KTitle1Index0DataModelK0,

  SlotG7KBody1Index0DataModelBodyK0,

  SlotG7KTitle2Index1DataModelK0,

  SlotG7KBody2Index1DataModelBodyK0,

  SlotG7KTitle3Index2DataModelK0,

  SlotG7KBody3Index2DataModelBodyK0,

  SlotG7KTitle4Index3DataModelK0,

  SlotG7KBody4Index3DataModelBodyK0,

  SlotG8Index0DataModel,

};